import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-124d7bb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"display":"flex","justify-content":"space-between","height":"100%","box-sizing":"border-box","padding":"6px 16px 16px"}
}
const _hoisted_2 = { class: "cm-ui-mr16" }
const _hoisted_3 = {
  class: "gap-x-4",
  style: {"display":"flex","align-items":"center","padding-right":"10px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info cm-ui-mr5",
  style: {"font-size":"18px","color":"var(--cm-color-primary)"}
}, null, -1))
const _hoisted_5 = { class: "" }
const _hoisted_6 = { style: {"font-weight":"bold","margin":"0 3px","color":"var(--cm-color-primary)"} }
const _hoisted_7 = {
  key: 0,
  class: "dot-flashing"
}

import { computed, nextTick, onMounted, onUnmounted, PropType, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue';
import CmForm from '@/components/cmForm/index.vue';
import {  FormActionType, FormItem, FormSize, FormSizeType, FormType } from '@/components/cmForm/types';
import { ExcludeRequestParams, QueryFormType, ScanState, ScanStateText } from '../types/sensitive-file-scanning';
import { GetSensitiveWordsResultsRequestParamsDataRow, GetSensitiveWordsSensitiveFilesResponseDataRow } from '../service';
import { computerInfoCols } from '../../ransomware-protection/types/ransomware-incident';
import { getAreaByTerminalType, getAuthByList, PermissionFe } from '@/services/service-permission.service';
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status';
import { AreaType } from '@/views/dashboard/service/_enum/area-type';
import { Group } from '@/views/dashboard/_type/group';
import { TerminalType } from '@/views/dashboard/_enum/terminal-type';
import { ElMessage } from 'element-plus';
import BaseTree from '@/views/dashboard/_components/group-tree/base-tree.vue';
import UnauthorizedTooltip from '@/views/dashboard/_components/unauthorized-tooltip/unauthorized-tooltip.vue'

import { IS_PRIVATE } from '@/common/const/env';
import { TableOpt } from '@/components/cmTable/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScanReport',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  hasPermission: {
    type: Boolean,
    required: false
  },
  api: {
    type: Object as PropType<{
      getSensitiveWordsResultsApi: () => void,
      getSensitiveWordsScanApi: (any) => void,
    }>,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const ModulePermissionKey = {
  [AreaType.normal]: PermissionFe.dlp_control,
}
const isDisabled = (row) => {
  return getAuthByList(row.auth_status, ModulePermissionKey[row.area_type]) !== TerminalAuthStatus.normal
}
const props = __props
const { t, locale } = useI18n()
const scanStateTextMap = computed<Record<number, string>>(() => {
  void locale.value
  return {
    [ScanState.Scanning]: t(ScanStateText[ScanState.Scanning]),
    [ScanState.Scanned]: t(ScanStateText[ScanState.Scanned]),
    [ScanState.ScannedFinish]: t(ScanStateText[ScanState.ScannedFinish]),
  }
})
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emits('update:modelValue', val)
  }
})
const timer = ref(null)
const scanningFlag = ref(false)
const toggleFold = ref(true)
const selectAll = ref(false)
const groupBySelected = ref(false)
const isIndeterminate = ref(false)
const formSize: FormSizeType = FormSize.Small
const isIndeterminateCmp = computed(() => data => data.some(item => item.$selected) && !data.every(item => item.$selected))

const formType = ref(FormActionType.Other)
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const queryForm = reactive<QueryFormType>({system_types: [1, 3]})
const queryFormDisabled = ref(!props.hasPermission)
const queryFormColumns = computed<FormItem<QueryFormType, ExcludeRequestParams>[]>(() => {
  void locale.value
  return [
    {
      prop: 'terminal_keyword',
      label: t('sensitiveFileScanning.computerName'),
      colOpt: { style: "flex: 0 0 auto; width: 260px" },
      hiddenAllLabel: true,
      modelModifiers: { trim: true },
      placeholder: t('sensitiveFileScanning.computerNamePlaceholder'),
      inputOpt: {
        'suffix-icon': 'el-icon-search',
      },
      events: {
        blur: () => void refreshList(),
        keypress: (e) => { e.charCode === 13 && void refreshList() },
      },
    },
  ]
})
const handleGroupSelected = (row: Group) => {
  if (!props.hasPermission) return;
  queryForm.group_id = row.group_id
  void refreshList()
}
const handleCheckbox = (row, data: GetSensitiveWordsResultsRequestParamsDataRow[]) => {
  data = data.filter(item => !isDisabled(item))
  row.$selected = !row.$selected
  selectAll.value = data.every(item => item.$selected)
  isIndeterminate.value = isIndeterminateCmp.value(data)
}
const handleAll = (data) => {
  data = data.filter(item => !isDisabled(item))
  for (let item of data) {
    item.$selected = selectAll.value
  }
  selectAll.value = data.every(item => item.$selected)
  isIndeterminate.value = isIndeterminateCmp.value(data)
}
const handleSelect = (data, type) => {
  data = data.filter(item => !isDisabled(item))
  const types = {
    all: () => {
      data = data.filter(item => !isDisabled(item))
      selectAll.value = !selectAll.value
      for (let item of data) {
        item.$selected = selectAll.value
      }
      isIndeterminate.value = isIndeterminateCmp.value(data)
    },
    reverse: () => {
      types['all']()
    },
    allGroup: () => {
      groupBySelected.value = true
      data = data.filter(item => !isDisabled(item))
      selectAll.value = true
      for (let item of data) {
        item.$selected = true
      }
      isIndeterminate.value = isIndeterminateCmp.value(data)
    },
    none: () => {
      groupBySelected.value = selectAll.value = false
      for (let item of data) {
        item.$selected = false
      }
    }
  }
  types[type]()
}
const menuLeftButtons = computed(() => {
  void locale.value
  return (ids, data) => [
    {
      type: 'internet',
      name: t('sensitiveFileScanning.scanReport'), disabled: () => (!props.hasPermission || !data.some(item => item.$selected)),
      opt: { type: 'primary', size: formSize,  },
      events: {
        click: async () => {
          let ids = data.filter(item => item.$selected).map(item => item.device_id)
          await props.api.getSensitiveWordsScanApi({device_ids: groupBySelected.value ? [] : ids,group_id:queryForm.group_id,select_type: ~~groupBySelected.value})
          const count = groupBySelected.value ? (tableRef.value?.rowData?.enable_total || 0) : ids.length
          ElMessage.success(t('sensitiveFileScanning.scanReportSuccess', { count }))
          scanningFlag.value = true
          clearInterval(timer.value)
          void refreshList()
        }
      }
    }
  ]
})
const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    'default-sort': { prop: 'service_count', order: 'descending' },
    height: '100%',
    bodyStyle: 'flex:1;padding:0',
    actionBarRowOptStyle: { 'margin-bottom': '0' },
    containerOpt: { style: 'padding: 0;margin-top: 15px;background: var(--cm-color-card-bg)' },
    disabled: !props.hasPermission,
    showActionBar: true,
    showForm: false,
    showTip: false,
    showRightToolbar: false,
    prefixTipText: t('sensitiveFileScanning.selectedCount'),
    suffixTipText: t('sensitiveFileScanning.terminalUnit'),
    path: 'data',
    rowKey: 'device_id',
    selection: false,
    columns: [
      { label: '', prop: 'id', width: 40, align: 'center' },
      ...computerInfoCols(false, false, t),
      { label: t('sensitiveFileScanning.scanState'), prop: 'scan_state', width: 100},

    ],
  }
})
onMounted(() => {
  timer.value = setInterval(async () => {
    await nextTick()
    scanningFlag.value && void refreshList()
  }, 1000 * 30)
})
onUnmounted(() => {
  scanningFlag.value = false
  clearInterval(timer.value)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((visible).value = $event)),
    title: _ctx.$t('sensitiveFileScanning.selectScanTerminal'),
    size: "75%",
    direction: "rtl",
    style: {"margin-top":"0"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BaseTree, {
            toggleFold: toggleFold.value,
            "onUpdate:toggleFold": _cache[0] || (_cache[0] = ($event: any) => ((toggleFold).value = $event)),
            disabled: !__props.hasPermission,
            onTerminalGroupSelected: handleGroupSelected,
            "terminal-type": [_unref(TerminalType).windows,_unref(TerminalType).windowsServer]
          }, null, 8, ["toggleFold", "disabled", "terminal-type"])
        ]),
        _createVNode(CmTable, {
          tableOpt: tableOpt.value,
          menuLeftButtons: menuLeftButtons.value,
          dataFormate: (data = []) => data.map((item = {}, index) => ({ area_type: _unref(getAreaByTerminalType)(item.system_type), $selected: groupBySelected.value, ...item })),
          disabled: queryFormDisabled.value,
          "first-loading": __props.hasPermission,
          "has-permission": __props.hasPermission,
          api: __props.api.getSensitiveWordsResultsApi,
          menuLeftColOpt: { span: 8 },
          menuRightColOpt: { span: 16 },
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
          pageOption: {
          pageNumName: 'page',
          pageSizeName: 'limit',
        },
          ref_key: "tableRef",
          ref: tableRef
        }, {
          "menu-right": _withCtx(() => [
            _createVNode(CmForm, {
              formSize: _unref(formSize),
              rowOpt: { style: 'justify-content: flex-end' },
              disabled: queryFormDisabled.value,
              "onUpdate:disabled": _cache[1] || (_cache[1] = ($event: any) => ((queryFormDisabled).value = $event)),
              modelValue: queryForm,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm) = $event)),
              formType: formType.value,
              "onUpdate:formType": _cache[3] || (_cache[3] = ($event: any) => ((formType).value = $event)),
              formColumns: queryFormColumns.value
            }, null, 8, ["formSize", "disabled", "modelValue", "formType", "formColumns"])
          ]),
          "tip-bar": _withCtx(({ data }) => [
            _createVNode(_component_el_row, {
              class: "is-plain",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "primary-bg el-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(tableOpt.value.prefixTipText), 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(groupBySelected.value ? (tableRef.value?.rowData?.enable_total || 0) : data.filter(item =>
                  item.$selected).length), 1),
                        _createTextVNode(_toDisplayString(tableOpt.value.suffixTipText), 1)
                      ])
                    ]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !data.length || groupBySelected.value,
                      onClick: ($event: any) => (handleSelect(data, 'all'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.selectAllPage')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !data.length || groupBySelected.value,
                      onClick: ($event: any) => (handleSelect(data, 'reverse'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.reversePage')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !data.length || groupBySelected.value,
                      onClick: ($event: any) => (handleSelect(data, 'allGroup'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.selectCurrentGroup')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !data.some(item => item.$selected),
                      onClick: ($event: any) => (handleSelect(data, 'none'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancelSelect')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          "id-header": _withCtx(({ data }: { data: GetSensitiveWordsResultsRequestParamsDataRow[] }) => [
            _createVNode(_component_el_checkbox, {
              modelValue: selectAll.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectAll).value = $event)),
              disabled: !data.length || groupBySelected.value,
              indeterminate: isIndeterminate.value,
              onChange: ($event: any) => (handleAll(data))
            }, null, 8, ["modelValue", "disabled", "indeterminate", "onChange"])
          ]),
          id: _withCtx(({ row, data }: { row: GetSensitiveWordsResultsRequestParamsDataRow, data: GetSensitiveWordsResultsRequestParamsDataRow[] }) => [
            _createVNode(UnauthorizedTooltip, {
              "permission-key": ModulePermissionKey[row.area_type],
              "device-id": row.device_id,
              "auth-status": _unref(getAuthByList)(row.auth_status, ModulePermissionKey[row.area_type]),
              "area-type": row.area_type,
              onAuthSuccess: _cache[5] || (_cache[5] = ($event: any) => (_unref(refreshList)()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  "model-value": row.$selected,
                  disabled: isDisabled(row) || groupBySelected.value,
                  onChange: ($event: any) => (handleCheckbox(row, data))
                }, null, 8, ["model-value", "disabled", "onChange"])
              ]),
              _: 2
            }, 1032, ["permission-key", "device-id", "auth-status", "area-type"])
          ]),
          scan_state: _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(scanStateTextMap.value[value] ?? '--') + " ", 1),
            (value === _unref(ScanState).Scanning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tableOpt", "menuLeftButtons", "dataFormate", "disabled", "first-loading", "has-permission", "api", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})